import { render, staticRenderFns } from "./RecipeView.vue?vue&type=template&id=de37475e&scoped=true"
import script from "./RecipeView.vue?vue&type=script&lang=js"
export * from "./RecipeView.vue?vue&type=script&lang=js"
import style0 from "./RecipeView.vue?vue&type=style&index=0&id=de37475e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de37475e",
  null
  
)

export default component.exports